<template>
  <b-container fluid>
    <b-row class="mb-3">
    <b-col cols="12" v-if="roleID==1">
      <router-link :to="{name: 'CustomerForm'}">
          <b-button variant="primary">
            <i class="fa fa-plus-circle"></i>&nbsp; Create New Customer
          </b-button>
      </router-link>
      </b-col>
    </b-row>

    <b-card>
    <div slot="header">
      <strong>Customer List</strong> <!-- <small>Table</small> -->
    </div>
    <!-- User Interface controls -->

      <b-row>
      <!-- <b-col cols="12" md="12" xl="5" class="my-2">
        <b-form-group label-cols-xl="5" label-align-xl="right" label="Search" class="mb-3"> -->
        <b-col cols="12" class="my-2">
        <b-form-group label="" class="mb-3">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- <b-col cols="12" md="12" xl="5" class="my-2">
        <b-form-group label="Sort" label-cols-xl="5" label-align-xl="right" class="mb-3">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
              <option :value="false">Asc</option> <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col> -->

      <!-- <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Sort direction" class="mb-0">
          <b-form-select v-model="sortDirection">
            <option value="asc">Asc</option>
            <option value="desc">Desc</option>
            <option value="last">Last</option>
          </b-form-select>
        </b-form-group>
      </b-col> -->


    </b-row>

    <!-- Main table element -->
    <b-table
      responsive
      id="customer-table"
      ref="table"
      hover
      show-empty
      :items="getAllCustomerSales"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      selectable
      :select-mode="'single'"
      selectedVariant="warning"
      @row-clicked="showMenus"
      :busy="isLoading"
    >

      <div slot="table-busy" class="text-center text-danger my-2">
        <div><img src="../assets/img/tbm_loader.gif" width="100" height="100"></div>
        <div style="margin-top: -20px"><small>Loading...</small></div>
      </div>

      <template slot="role_id" slot-scope="row">
          <b-badge href="#" pill variant="danger" v-if="row.item.role_id==5">{{row.item.role_name}}</b-badge>
          <b-badge href="#" pill variant="primary" v-if="row.item.role_id==6">{{row.item.role_name}}</b-badge>
      </template>

      <template slot="address" slot-scope="row">
        {{ row.item.address || {} }}, {{ row.item.village_name || {} }},
        {{ row.item.district_name || {} }}, {{ row.item.city_name || {} }},
         {{ row.item.province_name || {} }}
      </template>

      <template slot="data_owner.first_name" slot-scope="row">
        <!-- {{ console.log('row',row) }} -->
        {{ (row.item.data_owner || {}).first_name }} {{ (row.item.data_owner || {}).last_name }}
      </template>

      <template slot="sales_name" slot-scope="row">
        <!-- {{ console.log('row',row) }} -->
        {{ (row.item || {}).sales_name }}
      </template>

      <template slot="status" slot-scope="row">
          <b-badge href="#" pill variant="success" v-if="row.item.status==1">Active</b-badge>
          <b-badge href="#" pill variant="secondary" v-if="row.item.status==2">Inactive</b-badge>
      </template>

      <!-- <template slot="actions" slot-scope="row" v-if="roleID==1">

        <b-button size="sm" @click="activeConfirm(row.item)" class="mr-2 mb-2">
          {{ row.item.status == 2 ? 'Active' : 'Inactive' }}
        </b-button>

        <b-button size="sm" @click="row.toggleDetails" class="mr-2 mb-2">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} QR Code
        </b-button>

      </template> -->

      <template slot="row-details" slot-scope="row">
        <div>
          <b-row align-h="end">
            <b-button-group  class="mx-1 m-3">
              <b-button @click="editConfirm(row.item)" variant="outline-warning" v-if="roleID==1">Edit</b-button>

              <b-button @click="activeConfirm(row.item)" :variant="row.item.status == 2 ? 'outline-success' : 'outline-warning'">
                {{ row.item.status == 2 ? 'Active' : 'Inactive' }}
              </b-button>

              <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 mb-2">
                {{ row.detailsShowing ? 'Hide' : 'Show' }} QR Code
              </b-button> -->
            </b-button-group>
          </b-row>
        </div>

        <!-- <QRCode :qr_code_id="row.item.id.toString()" :kios_name="row.item.kios_name"></QRCode> -->

        <b-card no-body>
          <b-card-header>
            <b-row align-v="center">
              <b-col class="text-left">QR Code of {{row.item.kios_name}}</b-col>
              <b-col class="text-right"><b-button onclick="printJS({ printable: 'printQRCode', type: 'html', style: '#printQRCode {color:#008841; text-align:center;}' })" variant="primary">Print</b-button></b-col>
            </b-row>
          </b-card-header>
          <b-card-body :id="'card-qr-code'" align="center">
            <div id="printQRCode" style="color: #008841">
              <QRCode :qr_code_id="encrypt(row.item.id.toString())" :kios_name="row.item.kios_name"></QRCode>
              <!-- <QRCode :qr_code_id="row.item.id.toString()" :kios_name="row.item.kios_name"></QRCode> -->
            </div>
          </b-card-body>
        </b-card>


        <!-- <b-card no-body>
          <b-card-header> -->
          <!-- <b-row align-h="end" class="m"> -->

            <!-- <b-row align-v="center">
              <b-col class="text-left">QR Code of {{ row.item.kios_name }}</b-col> -->
                <!-- <b-col class="text-right"><b-button :qr-code-id="row.item.id" onclick="printJS({ printable: 'qr-code-'+qr-code-id, type: 'html', style: '#printQRCode {color:#008841; text-align:center;}' })" variant="primary">Print</b-button></b-col> -->
                <!--must be changed -->
                <!-- <b-col class="text-right"><b-button onclick="printJS({ printable: 'printQRCode', type: 'html', style: '#printQRCode {color:#008841; text-align:center;}' })" variant="primary">Print</b-button></b-col>
            </b-row>
            </b-card-header> -->
          <!-- </b-row> -->
          <!-- <b-card-body :id="'card-qr-code-'+row.item.id" align="center"> -->
        <!-- <b-card :id="'card-qr-code-'+row.item.id" align="center"> -->
            <!-- <div id="printQRCode" style="color: #008841"> -->
            <!-- <p align="mb-2"><h2>{{ row.item.kios_name }}</h2></p> -->
            <!-- <b-col class="text-right"><b-button onclick="printJS({ printable: 'printQRCode', type: 'html', style: '#printQRCode {color:#008841; text-align:center;}' })" variant="primary">Print</b-button></b-col> -->
              <!-- <div :id="'qr-code-' + row.item.id"><qrcode-vue :value="''+row.item.id" :size="160" level="H" foreground='#008841'></qrcode-vue></div> -->
            <!-- </div> -->
         <!-- <b-button size="sm" onclick="saveQR()" class="mt-3 mr-2 mb-2" variant="primary">Save</b-button> -->



    <!-- OUTPUT -->
          <!-- <img :src="output"> -->
          <!-- </b-card-body> -->

        <!-- </b-card> -->
      </template>

      <!-- <template slot="row-details" slot-scope="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template> -->
    </b-table>

    <br>

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>

    <b-modal title="Edit Data" class="modal-warning" v-model="editModal" @ok="editModal = false" ok-variant="warning">
      Are you sure to edit data?
    </b-modal>

    <b-modal title="Delete Data" class="modal-danger" v-model="deleteModal" @ok="deleteModal = false" ok-variant="danger">
      Are you sure to delete?
    </b-modal>

    <b-row align-h="center">
      <b-col col cols="8" sm="4" md="2" lg="2" class="mb-2">
        <!-- <b-form-select v-model="perPage" :options="pageOptions"></b-form-select> -->
        From {{rowFrom || '...'}} to {{rowTo || '...'}}
      </b-col>
      <b-col col cols="12" sm="8" md="8" lg="8">
          <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="rowTotal"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
      <b-col col cols="8" sm="4" md="2" lg="2" class="mb-2">
        <!-- <b-form-select v-model="perPage" :options="pageOptions"></b-form-select> -->
        Total {{rowTotal || '...' }} rows
      </b-col>
    </b-row>

  <!-- <b-row>

    <b-col col lg="2">
      <b-form-select v-model="perPage" :options="pageOptions" ></b-form-select>
    </b-col> -->
            <!-- <b-col md="3">
              <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
            </b-col>
            <b-col md="9"> -->
    <!-- <b-col col lg="8">
        <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class="my-0"
      ></b-pagination>
    <!-- </b-col>-->
    <!-- </b-col>
    <b-col col lg="2">
    </b-col>
  </b-row>   -->
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import { apiRouter } from '../router/api-routing.js'
import { isLoggedIn, getIdToken, removeToken, getDataToken, getHeaderToken, getRoleId } from '../user/token.js'
import Vue from 'vue'
import QrcodeVue from 'qrcode.vue'
// import html2canvas from 'html2canvas'
import printJS from 'print-js'
import QRCode from './QRCode'
var CryptoJS = require("crypto-js");
// import Canvas2Image from 'canvas2image'
//
// Vue.use(Canvas2Image)


export default {
    name: 'CustomerManagement',
    components: {
      QrcodeVue,
      QRCode
    },
    data() {
      return {
        props: ['qr-code-id'],
        customerList: null,
        fields: [
          { key: 'id', label: 'Customer ID', sortable: false },
          { key: 'kios_name', label: 'Customer Name', sortable: false },
          { key: 'role_id', label: 'Customer Type', sortable: false },
          { key: 'address', label: 'Address', sortable: false },
          { key: 'data_owner.first_name', label: 'Owner', sortable: false },
          { key: 'status', label: 'Status', sortable: false }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 15,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        editModal: false,
        deleteModal: false,
        isLoading: false,
        roleID: '',
        rowIdPrevClicked: 0,

        output: null,
        isBusy: false,
        rowFrom: '',
        rowTo: '',
        rowTotal: ''
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
    watch: {
    },
    created(){
      this.checkSession()
      this.roleID = getRoleId()

      // if (getRoleId()==1){
      //   this.fields.push({ key: 'actions', label: 'Action' })
      // }
      // this.getAllCustomerSales(this)

    },
    mounted() {
    },
    methods: {
      checkSession(){
        if(isLoggedIn() === 1){
        } else {
          this.$router.push({name: 'Login'})
        }
      },
      encrypt(qrCodeValue){
        //console.log("oke", window.btoa(CryptoJS.AES.encrypt(qrCodeValue, process.env.SECRET_KEY)))
        return window.btoa(CryptoJS.AES.encrypt(qrCodeValue, process.env.SECRET_KEY));
      },
      printQRCode: function(){
        // console.log('yukprint')
        printJS({ printable: 'printQRCode', type: 'html', style: '#printQRCode {color:#008841; text-align:center;}' })
      },
      saveQR(){
        var imageFoo = document.getElementById('printQRCode')
        imageFoo.src = canvas.toDataURL()
      },
      async getAllCustomers(){
        let api
        if(this.roleID==1){
          api = apiRouter().customers
        } else {
          // console.log('dapet', this.roleID)
          api = apiRouter().customers_sales
        }

        this.isLoading = true
        let $vm = this
        $vm.customerList = null
        await axios.get(api, getHeaderToken())
        .then(response => {
          $vm.isLoading = false;
            // console.log('hallo', response);
            //document.getElementById('testLoading').click();
            if(response.status === 200){
                //console.log("suksessss");
                // console.log(response.data);
                // console.log('bosku', response.data);
                let push = []
                for(var i = 0; i < response.data.length; i++){

                  if (response.data[i].role_id == 5){
                    response.data[i].role_id = 'Dealer';

                  } else if (response.data[i].role_id == 6){
                    response.data[i].role_id = 'Kios';

                  }
                  //console.log("abc " + response.data[i].role_id);
                  push.push(response.data[i]);

                }

                // console.log('tag', push);
                $vm.$nextTick(()=>{
                  $vm.customerList = push
                  // Set the initial number of items
                  this.totalRows = $vm.customerList.length
                  //console.log($vm.customerList);
                })
                //this.$root.$emit('bv::refresh::table', 'customer-table')


            } else {
              // console.log("response not 200");
            }
          })
          .catch(function (error) {
            $vm.isLoading = false;
              // console.log(error);
          });
      },
      // '../json/response.json'
      getAllCustomerSales(ctx) {
        // console.log('ctx', ctx)
        // console.log('current page', ctx.currentPage)

        const promise = axios.get(apiRouter().customers_sales + '?search=' + ctx.filter + '&page=' + ctx.currentPage, getHeaderToken())

        // Must return a promise that resolves to an array of items
        return promise.then(data => {
          // Pluck the array of items off our axios response
          // console.log('data', data.data)

          // this.customerList = data.data.data
          // let $rd = this
          this.rowFrom = data.data.from
          this.rowTo = data.data.to
          // console.log('rowTo', rowTo)
          this.rowTotal = data.data.total
          // this.totalRows = data.data.total

          const items = data.data.data
          this.customerList = data.data.data
          this.currentPage = ctx.currentPage
          // Must return an array of items or an empty array if an error occurred
          return items || []
        })
      },
      reloadPage(){
        window.location.reload()
      },
      rowSelected(items) {
        //console.log("rowSelected " + items)
        //this.selected = items
      },
      showMenus(row){
        // console.log('customerList', this.customerList)
        if (this.roleID==1){
          this.customerList.forEach(a => { //hide toggle
            if (row.id == a.id){  //show-hide same row
              row._showDetails = !row._showDetails
            } else {
              a._showDetails = false
            }
          })
        }


        // console.log('id klik',row.id)
        //if (this.roleID==1){

          //console.log('aaa', this.customerList)

          // this.customerList.forEach(a => { //hide toggle
          //   // a._showDetails = false
          //   if (row.id == a.id){  //show-hide same row
          //     row._showDetails = !row._showDetails
          //   } else {
          //     a._showDetails = false
          //   }
          // })

          // if (row.id != this.rowIdPrevClicked){  //show-hide same row
          //   row._showDetails = !row._showDetails
          // }
          //
          // this.rowIdPrevClicked = row.id
        //}
      },
      editConfirm(item) {

        if (this.roleID==1){
          var name = item.kios_name
          var message = 'Are you sure to edit data ' + name +'?'

          this.$swal({title: message, html:'',text: '',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Edit Data',
            confirmButtonColor: '#FFC107',
            showCloseButton: false,
            showLoaderOnConfirm: true,
          })
          .then((result) => {
              if (result.value) {
                // (console.log('item', item))
                this.$router.replace({name: 'CustomerFormEdit', params: {customer_id: item.id}});
              }
            })
         }
      },
      activeConfirm(item) {
        var name = item.kios_name

        if (item.status == 1){ //Active now
          this.updateStatus('2', name, item.id)

        } else if (item.status == 2){ //Inactive now
          this.updateStatus('1', name, item.id)

        } else {
          this.updateStatus('2', name, item.id)
        }
      },
      updateStatus(status, name, customer_id){
        var action;
        var buttonVariant;

        if (status == 1){
          action = 'Active'
          buttonVariant = '#4DBD74' //'#008841' //'#4DBD74'

        } else if (status == 2){
          action = 'Inactive'
          buttonVariant = '#FFC107'

        }

        let message = 'Are you sure to Set ' + action + ' for ' + name +'?'

        // this.$bvModal.msgBoxConfirm('Are you sure to set ' + action + ' for ' + name +'?', {
        //     title: action + ' Confirmation',
        //     size: 'sm',
        //     buttonSize: 'sm',
        //     okVariant: buttonVariant,
        //     okTitle: 'Set ' + action,
        //     cancelTitle: 'Cancel',
        //     headerClass: 'p-2 border-bottom-0',
        //     footerClass: 'p-2 border-top-0',
        //     centered: true
        //   })
        this.$swal({title: message, html:'',text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Set ' + action,
          confirmButtonColor: buttonVariant,
          showCloseButton: false,
          showLoaderOnConfirm: true,
        })
        .then((result) => {
            if(result.value) {

              axios.post(apiRouter().update_customers_status + customer_id, {'status': status}, getHeaderToken())
              .then(response => {
                //console.log("response", response)
                  if(response.status == 200){
                    this.modalOK('Set ' + action + ' for ' + name + ' successfully', 'success', 'CustomerManagement')

                  } else {
                    this.modalOK('Set ' + action + ' for ' + name + ' failed', 'error', '')

                  }
              }) .catch(function (error) {
                  this.modalOK('Set ' + action + ' for ' + name + ' failed', 'error', '')
              });
            } else {

            }
          }) .catch(err => {
            // An error occurred
          })
      },
      modalOKv2(message, buttonVariant, page){
        this.$bvModal.msgBoxOk(message, {
          title: 'Report',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: buttonVariant,
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        }).then(value => {
          if (page == ''){
          } else {
            //this.$router.push({name: page});
            this.reloadPage();
          }
        })
        .catch(err => {
          // An error occurred
        })
      },
      modalOK(message, buttonVariant, page){
       this.$swal({title: message, html:'',text: '',
          type: buttonVariant,
          showCancelButton: false,
          confirmButtonText: 'OK',
          confirmButtonColor: '#4DBD74',
          showCloseButton: false,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (page == ''){
          } else {
            //this.$router.push({name: page});
            this.reloadPage();
          }
        });
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = "abcdefghij"
        // this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        // this.rowTotal = filteredItems.length
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        // this.currentPage = 1
      },
      printDivById(divName) {
        // this.print()
        // var elem = document.getElementById('card-qr-code-' + divName);
        var elem = document.getElementById('printQRCode')
        this.printElem(elem)
        // var printContents = document.getElementById('card-qr-code-' + divName).innerHTML;
        // var originalContents = document.body.innerHTML;
        //
        // document.body.innerHTML = printContents;
        // window.print();
        // document.body.innerHTML = originalContents;

        // html2canvas(document.querySelector('card-qr-code-' + divName)).then(canvas => {
        //  //document.body.appendChild(canvas)
        //  document.body.innerHTML = canvas;
        // window.print();
        // document.body.innerHTML = originalContents;

        //  });
      },
      printElem(elem) {
          var mywindow = window.open('', 'Print', 'height=600,width=800');

          mywindow.document.write('<html><head><title>Print</title>');
          mywindow.document.write('</head><body >');
          mywindow.document.write(elem.outerHTML);
          mywindow.document.write('</body></html>');

          mywindow.document.close();
          mywindow.focus()
          mywindow.print();
          mywindow.close();
          return true;
      },
      sortingChanged(ctx) {
        // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
        // ctx.sortDesc ==> true if sorting descending, false otherwise

        // console.log('sortingChanged(ctx)',ctx)
        // console.log('sortBy',this.sortBy)
        // console.log('sortDesc',this.sortDesc)
        ctx.sortBy = this.sortBy
        ctx.sortDesc = this.sortDesc
      }
    }
  }
</script>
